import React from 'react';
import Joyride from 'react-joyride';
import {
  liveEventsProps,
  getSendEventProps,
  sampleSourceProps,
  getLiveEventTabProps,
} from './utils';

export const SampleSourceOnboarding = () => <Joyride {...sampleSourceProps} />;

export const LiveEventsOnboarding = () => <Joyride {...liveEventsProps} />;

export const SendEventOnboarding = ({ onCopy }: { onCopy: () => void }) => (
  <Joyride {...getSendEventProps(onCopy)} />
);

interface Props {
  enable: boolean;
}

export const LiveEventTabOnboarding = ({ enable }: Props) => (
  <Joyride {...getLiveEventTabProps(enable)} />
);

export { SendEventTarget, SampleSourceTarget, LiveEventsTarget } from './utils';
